import * as LocationActions from '../../actions/LocationActions'
import * as GeometryActions from '../../actions/GeometryActions'

const google = window.google

class MapMarker {
  icons = {
    active: {},
    inactive: {}
  }

  constructor(location, map) {
    this.map = map;

    this.icons = {
      inactive: {
        url: location.OfficeType.InactiveImageUrl,
        size: new google.maps.Size(47, 63),
        scaledSize: new google.maps.Size(47, 63)
      },
      active: {
        url: location.OfficeType.ActiveImageUrl,
        size: new google.maps.Size(47, 63),
        scaledSize: new google.maps.Size(47, 63)
      }
    }

    // Initialize new marker
    this.marker = new google.maps.Marker({
      map: this.map,
      position: {
        lat: location.Latitude,
        lng: location.Longitude
      },
      animation: google.maps.Animation.DROP,
      title: location.OfficeType.Name,
      icon: this.icons.inactive
    })

    // Add functions to marker
    this.marker.id = location.Id
    this.marker.icons = this.icons
    this.marker.setMarkerActive = this.setMarkerActive
    this.marker.setMarkerInactive = this.setMarkerInactive

    // Events
    this.marker.addListener('click', () => {
      // Calculate new geometry so we can re-center the map
      let geometry = new google.maps.LatLng(
        location.Latitude,
        location.Longitude
      )
      GeometryActions.change(geometry)

      // Fire action
      LocationActions.setSelectedSearchResult(location.Id)

      // Update marker icon
      this.setMarkerActive(this.marker)
    })

    return this.marker
  }

  // Set marker icon to active state
  setMarkerActive() {
    if (typeof this.setIcon === 'function' && this.icons.active !== undefined) {
      this.setIcon(this.icons.active)
    }
  }

  // Set marker icon to inactive state
  setMarkerInactive() {
    if (
      typeof this.setIcon === 'function' &&
      this.icons.inactive !== undefined
    ) {
      this.setIcon(this.icons.inactive)
    }
  }
}

export default MapMarker
